// extracted by mini-css-extract-plugin
module.exports = {"campaignsTable":"ManuallyMappedCampaigns-module__campaignsTable___1Nw8R","fullWidth":"ManuallyMappedCampaigns-module__fullWidth___3lDSp"};